import { addToChainAfter, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getReviewAndPayCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = Handler<
    | ({
          cartId: string;
          shouldLoadFullCart?: boolean;
          getPromotions?: boolean;
      } & HasOnSuccess)
    | ({
          apiParameter: GetCartApiParameter;
      } & HasOnSuccess),
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;

export const PopulateApiParameterCustom: HandlerType = props => {
    const state = props.getState();
    const reviewAndPayCartState = getReviewAndPayCartState(state);
    const pageType = getCurrentPage(state).type;
    const isCheckoutReviewAndSubmitPage = pageType === "CheckoutReviewAndSubmitPage";

    console.log("obj", { reviewAndPayCartState, pageType, isCheckoutReviewAndSubmitPage });

    if (isCheckoutReviewAndSubmitPage && props.apiParameter.cartId === reviewAndPayCartState?.id) {
        props.apiParameter?.expand?.push(`${new Date().getTime()}` as any); // cache buster to ensure we get the latest cart when loading by cartId
    }
};

addToChainAfter(chain, PopulateApiParameter, PopulateApiParameterCustom);
